/* ==========================================================================
   ReLEAF — Ready-to-Wear product page behaviour
   1. Variant sync: price, availability and the hidden id, driven from the
      variant JSON Liquid printed into the page rather than guessed from the DOM.
   2. Size guide disclosure: opened by the link beside the size selector.
   Bound to shopify:section:load so it survives the Theme Editor re-rendering.
   ========================================================================== */
window.ReLEAFRTW = (function () {
  "use strict";

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var amount = parts.join(".");
    if (format && format.indexOf("{{") !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, amount);
    }
    return "$" + amount;
  }

  /* ------------------------------------------------------ 1. size guide */
  function initSizeGuide() {
    var guide = document.getElementById("rl-size-guide");

    document.querySelectorAll("[data-rl-sizeguide-open]").forEach(function (btn) {
      if (btn.dataset.rlBound) return;
      btn.dataset.rlBound = "1";
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var target = document.getElementById("rl-size-guide");
        if (!target) return;
        target.open = true;
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        var sum = target.querySelector("summary");
        if (sum) sum.focus({ preventScroll: true });
      });
    });

    // Deep link support: /products/x#rl-size-guide opens it
    if (guide && window.location.hash === "#rl-size-guide") guide.open = true;
  }

  /* --------------------------------------------------- 2. variant sync */
  function initProduct(root) {
    var scope = root || document;
    var form = scope.querySelector("[data-rl-rtw-form]");
    if (!form) return;

    var dataEl = scope.querySelector("[data-rl-rtw-variants]");
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return; // malformed JSON: leave the form exactly as Liquid rendered it
    }
    if (!variants || !variants.length) return;

    var selects = Array.prototype.slice.call(scope.querySelectorAll("[data-rl-rtw-option]"));
    var idField = form.querySelector('input[name="id"]');
    var button = scope.querySelector("[data-rl-rtw-add]");
    var label = scope.querySelector("[data-rl-rtw-add-label]");
    var priceEl = scope.querySelector("[data-rl-rtw-price]");
    var moneyFormat = document.body.getAttribute("data-money-format") || "";

    var STR = {
      add: dataEl.getAttribute("data-add") || "Add to cart",
      soldOut: dataEl.getAttribute("data-sold-out") || "Sold out",
      unavailable: dataEl.getAttribute("data-unavailable") || "Unavailable"
    };

    // Optional spec readout keyed off the selected size value
    var specMap = {};
    var specEl = scope.querySelector("[data-rl-rtw-specmap]");
    if (specEl) {
      try { specMap = JSON.parse(specEl.textContent) || {}; } catch (e) { specMap = {}; }
    }
    var specOut = {
      arch: scope.querySelector("[data-rl-spec-arch]"),
      hdpe: scope.querySelector("[data-rl-spec-hdpe]"),
      weight: scope.querySelector("[data-rl-spec-weight]")
    };

    function chosen() {
      return selects.map(function (s) { return s.value; });
    }

    function match(values) {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options || [];
        if (values.length !== opts.length) continue;
        var same = true;
        for (var j = 0; j < values.length; j++) {
          if (opts[j] !== values[j]) { same = false; break; }
        }
        if (same) return variants[i];
      }
      return null;
    }

    function updateSpec(values) {
      if (!specEl) return;
      // Match on whichever chosen value has an entry in the map
      var hit = null;
      for (var i = 0; i < values.length; i++) {
        var key = String(values[i]).trim();
        if (specMap[key]) { hit = specMap[key]; break; }
        for (var k in specMap) {
          if (key.indexOf(k) !== -1) { hit = specMap[k]; break; }
        }
        if (hit) break;
      }
      if (!hit) return;
      if (specOut.arch) specOut.arch.textContent = hit.arch || "\u2014";
      if (specOut.hdpe) specOut.hdpe.textContent = hit.hdpe || "\u2014";
      if (specOut.weight) specOut.weight.textContent = hit.weight || "\u2014";
    }

    function update() {
      var values = chosen();
      updateSpec(values);

      var variant = match(values);
      if (!variant) {
        if (idField) idField.value = "";
        if (button) button.disabled = true;
        if (label) label.textContent = STR.unavailable;
        return;
      }

      if (idField) idField.value = variant.id;
      if (button) button.disabled = !variant.available;
      if (label) label.textContent = variant.available ? STR.add : STR.soldOut;

      if (priceEl && typeof variant.price === "number") {
        var html = "<strong>" + money(variant.price, moneyFormat) + "</strong>";
        if (variant.compare_at_price > variant.price) {
          html += " <s>" + money(variant.compare_at_price, moneyFormat) + "</s>";
        }
        priceEl.innerHTML = html;
      }

      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url.toString());
        } catch (e) { /* non-blocking */ }
      }
    }

    selects.forEach(function (s) {
      if (s.dataset.rlBound) return;
      s.dataset.rlBound = "1";
      s.addEventListener("change", update);
    });
    update();
  }

  function initAll() { initProduct(document); initSizeGuide(); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function () { initAll(); });

  return { initAll: initAll, initProduct: initProduct, initSizeGuide: initSizeGuide };
})();
